// import wagerwizlogo from '../../assets/images/wagerwizlogo_v1.svg';
import wagerwizlogonew from '../../assets/wagerwizlogomarch.svg';
import wagerwizlogo_desktop from '../../assets/WagerWiz_OnDark_Vector.svg';

import getnotifieddiscord from '../../assets/images/get_notified_discord.svg';
import getnotifieddiscordhighlighted from '../../assets/images/get_notified_discord_highlighted.svg';
// import emptyuser from '../../assets/images/empty_user.svg';
import downicon from '../../assets/images/down_icon.svg';
import './TopBarSignedIn.css';
import { useEffect, useRef, useState, useCallback } from 'react';
import { Modal, Popover, Tooltip } from '@mui/material';
import editicon from '../../assets/images/edit_icon.svg';
import youtubeicon from '../../assets/images/youtube_icon.svg';
import discordicongrey from '../../assets/images/discord_icon_grey.svg';
import settingsicon from '../../assets/images/settings_icon_grey.svg';
import logouticon from '../../assets/images/logout_icon.svg';
import { googleLogout } from '@react-oauth/google';
import discordicon from '../../assets/images/discord_logo_icon.svg';
// import { saveUserInfo } from '../../utils/api/saveUserInfo';
import { verifyDiscordUsername } from '../../utils/api/verifyDiscordUsername';
// import verifiedicon from '../../assets/images/successfully_verified_icon.svg';
import { LogoutButton } from '../LogoutButton/LogoutButton';
import { saveBankroll } from '../../utils/api/saveBankroll';
import axios from 'axios';
import discord_logo_icon from '../../assets/images/discord_logo_icon.svg';
import filter_icon from '../../assets/images/filter_icon.svg';
import close_icon from '../../assets/images/close_icon.svg';

import { IOSSwitch } from '../IOSSwitch';
import { setDiscordEnabled } from '../../utils/api/setDiscordEnabled';
import { UpgradeModal } from '../UpgradeModal/UpgradeModal';
import { useAuth0 } from '@auth0/auth0-react';
import { VimeoEmbed } from '../../pages/landing/VideoEmbed';
import { SidebarMobile } from '../SideBar/SidebarMobile';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { SessionExpiredModal } from '../SessionExpiredModal/SessionExpiredModal';

// const stripe = require('stripe')('sk_test_51QiNskRs9Kxk3FYqq3ks9KuZ6QrafEiGA3wSUv3eMznoiweyG4is7wyEdwd46KFQJAirzRYhphdXzITOvG1X1Ekh00pt5N0Bve');

export const TopBarSignedIn = (props) => {
	const { bankroll, setBankroll, email, filtersOpen, setFiltersOpen, isMobile } = props;
	// console.log('props: ', props);
	const [isProfileOpen, setIsProfileOpen] = useState(false);
	const [isDiscordOpen, setIsDiscordOpen] = useState(false);

	const [isDiscordEnabled, setIsDiscordEnabled] = useState(JSON.parse(window.localStorage.getItem('userdb'))?.discord_enabled === 'true' || false);

	const [bankrollEditable, setBankrollEditable] = useState(false);
	// Local state fallback for when setBankroll prop is not available
	const [localBankroll, setLocalBankroll] = useState(bankroll || JSON.parse(window.localStorage.getItem('userdb'))?.user_data?.[0]?.bankroll || 10000);
	const bankrollSaveTimeoutRef = useRef(null);
	
	// Sync localBankroll with prop when it changes
	useEffect(() => {
		if (bankroll !== undefined && bankroll !== null) {
			setLocalBankroll(bankroll);
		}
	}, [bankroll]);
	
	// Use localBankroll if setBankroll is not available
	const displayBankroll = setBankroll ? bankroll : localBankroll;
	
	// Function to save bankroll with debouncing
	const saveBankrollDebounced = useCallback((value, userEmail) => {
		// Clear any existing timeout
		if (bankrollSaveTimeoutRef.current) {
			clearTimeout(bankrollSaveTimeoutRef.current);
		}
		
		// Set new timeout
		bankrollSaveTimeoutRef.current = setTimeout(async () => {
			if (!value || value === '' || isNaN(parseFloat(value))) {
				return;
			}
			
			const currentUserdb = JSON.parse(window.localStorage.getItem('userdb'));
			const emailToUse = userEmail || email || currentUserdb?.email;
			
			if (!emailToUse) {
				console.log('No email available for bankroll save');
				return;
			}
			
			try {
				const copy = JSON.parse(window.localStorage.getItem('userdb'));
				if (copy?.user_data) {
					for (const c of copy.user_data) {
						c.bankroll = value;
					}
					window.localStorage.setItem('userdb', JSON.stringify(copy));
				}
				await saveBankroll(value, emailToUse);
				console.log('Bankroll saved:', value, 'for email:', emailToUse);
			} catch (e) {
				console.error('Error saving bankroll:', e);
			}
		}, 500);
	}, [email]);
	
	// Cleanup timeout on unmount
	useEffect(() => {
		return () => {
			if (bankrollSaveTimeoutRef.current) {
				clearTimeout(bankrollSaveTimeoutRef.current);
			}
		};
	}, []);
	
	// Format number with commas
	const formatNumber = (num) => {
		if (!num && num !== 0) return '';
		const numStr = String(num);
		// Handle decimal numbers
		if (numStr.includes('.')) {
			const [integer, decimal] = numStr.split('.');
			return integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + decimal;
		}
		return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};

	let user = {};
	const [userdb, setuserdb] = useState(window.localStorage.getItem('auth0user') !== 'undefined' && JSON.parse(window.localStorage.getItem('userdb')));
	// let userdb = {};
	if (window.localStorage.getItem('auth0user') !== 'undefined') {
		user = JSON.parse(window.localStorage.getItem('auth0user'));
		// userdb = JSON.parse(window.localStorage.getItem('userdb'));
	}
	// const user = JSON.parse(window.localStorage.getItem('auth0user'));
	// console.log('auth0user: ', user);

	// const userbankroll = JSON.parse(window.localStorage.getItem('userdb'))?.user_data?.[0]?.bankroll;

	// const [bankroll, setBankroll] = useState(userbankroll || 10000)
	const isOracle =
		userdb?.stripe_plan?.nickname?.includes('Oracle') &&
		userdb?.stripe_plan.active &&
		userdb?.stripe_subscription !== null &&
		userdb?.stripe_status !== 'deleted' &&
		userdb.stripe_status !== 'past_due' &&
		userdb.stripe_status !== 'past_due';
	const { logout } = useAuth0();

	// useEffect(() => {
	// 	const updateBankroll = async () => {
	// 		const copy = JSON.parse(window.localStorage.getItem('userdb'))?.user_data;
	// 		try {
	// 			for (const c of copy) {
	// 				c.bankroll = bankroll;
	// 			}

	// 			// console.log('updating bankroll');

	// 			// await saveUserInfo(copy, window.localStorage.getItem('userdb')?.email);
	// 			await saveBankroll(bankroll, JSON.parse(window.localStorage.getItem('userdb'))?.email);
	// 		} catch (e) {
	// 			console.log('e: ', e);
	// 		}
	// 	};
	// 	updateBankroll();
	// }, [bankroll]);

	// Debounced bankroll save for bankroll prop (when setBankroll is available)
	useEffect(() => {
		if (setBankroll && typeof setBankroll === 'function' && bankroll && !isNaN(parseFloat(bankroll))) {
			const userdbCopy = JSON.parse(window.localStorage.getItem('userdb'));
			const emailToUse = email || userdbCopy?.email;
			if (emailToUse) {
				saveBankrollDebounced(bankroll, emailToUse);
			}
		}
	}, [bankroll, setBankroll, email, saveBankrollDebounced]);

	const [anchorEl, setAnchorEl] = useState(null);
	const [anchorElDiscord, setAnchorElDiscord] = useState(null);
	const [discordUsername, setDiscordUsername] = useState('');
	const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
	const { getAccessTokenSilently, isAuthenticated, user: userAuth0 } = useAuth0();
	// const profile = JSON.parse(window.localStorage.getItem('profile'));
	const profilepic = user?.picture;
	const profilename = user?.name;
	// const email = JSON.parse(window.localStorage.getItem('userdb'))?.email;
	// console.log('email: ', email);

	const bankrollbuttonref = useRef('bankroll');

	const [paymentLink, setPaymentLink] = useState('');
	const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

	// TODO: reactivate stripe payment links
	async function createPaymentLink() {
		try {
			const access_token = window.localStorage.getItem('access_token');
			const res = await axios.post(
				`${process.env.REACT_APP_BACKEND_URL}/create_customer_portal_session?email=${email}`,
				{ email },
				{
					headers: {
						Authorization: `Bearer ${access_token}`,
					},
				}
			);

			setPaymentLink(res.data.url);
		} catch (e) {
			console.error(e);
		}
	}
	useEffect(() => {
		if (paymentLink === '' && email) {
			createPaymentLink();
		}
	}, []);

	useEffect(() => {
		if (bankrollEditable && bankrollbuttonref.current) {
			// Use setTimeout to ensure the input is rendered before focusing
			const timer = setTimeout(() => {
				if (bankrollbuttonref.current) {
					bankrollbuttonref.current.focus();
				}
			}, 10);
			return () => clearTimeout(timer);
		}
	}, [bankrollEditable]);

	useEffect(() => {
		// Listen to changes in the userdb storage variable from other components
		const handleStorageChange = (event) => {
			if (event.type === 'storage') {
				const newuserdb = JSON.parse(window.localStorage.getItem('userdb'));
				setuserdb(newuserdb); // Update state when localStorage changes
				setIsDiscordEnabled(newuserdb.discord_enabled === 'true' || false);
			}
		};

		window.addEventListener('storage', handleStorageChange);
		return () => window.removeEventListener('storage', handleStorageChange);
	}, []);

	const [plan, setPlan] = useState('Free');

	const [isSessionExpired, setIsSessionExpired] = useState(false);

	useEffect(() => {
		const registerUserLocally = async () => {
			if (isAuthenticated && userAuth0) {
				try {
					const token = await getAccessTokenSilently();

					// Send user data to your backend
					const u = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user`, userAuth0, {
						headers: {
							Authorization: `Bearer ${token}`,
						},
					});
					window.localStorage.setItem('userdb', JSON.stringify(u.data));
					if (u.data?.stripe_plan) {
						if (u.data.stripe_plan?.nickname?.includes('Apprentice') && userdb?.stripe_status !== 'deleted' && userdb.stripe_status !== 'past_due') {
							setPlan('🔨 Apprentice');
						} else if (u.data.stripe_plan?.nickname?.includes('Visionary') && userdb?.stripe_status !== 'deleted' && userdb.stripe_status !== 'past_due') {
							setPlan('🔮 Visionary');
						} else if (u.data.stripe_plan?.nickname?.includes('Oracle') && userdb?.stripe_status !== 'deleted' && userdb.stripe_status !== 'past_due') {
							setPlan('🔮 Oracle');
						}
					}
				} catch (error) {
					// Show session expired modal for any authentication-related error status codes
					if (error.response?.status >= 400) {
						setIsSessionExpired(true);
						window.localStorage.clear(); // Clear all local storage
					}
				}
			}
		};

		registerUserLocally();
	}, [getAccessTokenSilently]);

	return (
		<div style={{ backgroundColor: '#17191d' }}>
			<SessionExpiredModal isOpen={isSessionExpired} />
			<UpgradeModal isOpen={isUpgradeModalOpen} setIsOpen={setIsUpgradeModalOpen} />
			<div style={{ minHeight: '72px', color: '#17191d', borderBottom: '1px solid #303033' }} className="flex flex-row">
				<div
					className="flex flex-row cursor-pointer"
					style={{ color: 'white', fontFamily: 'Poppins' }}
					onClick={() => {
						if (!isMobile) {
							window.location.href = '/';
						}
					}}>
					{!isMobile && <img className="ml-4" src={wagerwizlogo_desktop} alt="wager wiz logo" height={225} width={225} />}
					{isMobile && <SidebarMobileMenuButton bankroll={bankroll} setBankroll={setBankroll} email={email} profilepic={profilepic} profilename={profilename} paymentLink={paymentLink} />}
				</div>

				<div className="flex flex-row" style={{ width: '100%', justifyContent: 'end', alignItems: 'center' }}>
					{!isMobile && (
						<div
							style={{ color: 'white', marginTop: 'auto', marginBottom: 'auto', marginLeft: 'auto', marginRight: 60 }}
							onClick={() => {
								window.location.href = '/';
							}}
							className="cursor-pointer mr-8">
							Home
						</div>
					)}
					{!isMobile && (
						<div
							style={{ color: 'white', marginTop: 'auto', marginBottom: 'auto', marginRight: 'auto' }}
							onClick={() => {
								window.location.href = '/pricing';
							}}
							className="cursor-pointer">
							Pricing
						</div>
					)}

					{userdb?.discord_verified && (
						<div
							onClick={(e) => {
								setAnchorElDiscord(e.currentTarget);
								setIsDiscordOpen(!isDiscordOpen);
							}}
							className="flex flex-row cursor-pointer discord-header"
							style={{ backgroundColor: '#22262e', borderRadius: 12, padding: 12, height: 40, alignSelf: 'center', marginLeft: 10 }}>
							<img width={24} height={24} src={discord_logo_icon} alt="discord logo" />
							<div
								style={{
									width: 8,
									height: 8,
									backgroundColor: isDiscordEnabled ? '#47E338' : 'red',
									borderRadius: '50%',
									alignSelf: 'center',
									marginLeft: 12,
								}}
							/>
							<div style={{ color: 'white', alignSelf: 'center', marginLeft: 12 }}>{userdb?.discord_username_original}</div>
						</div>
					)}
					{!userdb?.discord_verified && (
						<img
							onMouseOver={(e) => (e.currentTarget.src = getnotifieddiscordhighlighted)}
							onMouseOut={(e) => (e.currentTarget.src = getnotifieddiscord)}
							src={getnotifieddiscord}
							alt="get notified discord"
							className="mt-3 cursor-pointer discord-notification-button"
							id="discord-notification-button"
							style={{ marginLeft: 'auto', marginTop: 'auto', marginBottom: 'auto' }}
							onClick={(e) => {
								if (isOracle) {
									setAnchorElDiscord(e.currentTarget);
									setIsDiscordOpen(!isDiscordOpen);
								} else {
									setIsUpgradeModalOpen(true);
								}
							}}
						/>
					)}

					<div
						onClick={(e) => {
							setAnchorEl(e.currentTarget);
							setIsProfileOpen(!isProfileOpen);
						}}
						className="cursor-pointer image-cropper menubar flex flex-row mr-3">
						<img referrerPolicy="no-referrer" width={40} style={{ borderRadius: '50%' }} className="mr-4 ml-3 mt-1" src={profilepic} alt="user icon" />
						<img src={downicon} alt="down icon" className="profile-dropdown-arrow" />
					</div>
					<Popover
						open={isProfileOpen}
						anchorEl={anchorEl}
						id="user menu"
						onClose={() => {
							setIsProfileOpen(false);
						}}
						sx={{
							'& .MuiPaper-root': {
								backgroundColor: '#17191d', // Your desired color
							},
						}}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}>
						<div style={{ backgroundColor: '#17191d' }}>
							<div className="flex flex-row">
								<div className="cursor-pointer image-cropper mr-3">
									<img referrerPolicy="no-referrer" width={40} style={{ borderRadius: '50%' }} className="mr-4 ml-3 mt-1" src={profilepic} alt="user icon" />
								</div>
								<div className="text-2xl" style={{ color: '#f0f2f8', minWidth: '280px', alignContent: 'center', marginLeft: '-20px' }}>
									{profilename}
								</div>
							</div>
							<div style={{ color: 'white', fontSize: 12 }} className="ml-5">
								Plan: {plan}
							</div>
							<div className="mt-4 mb-4 ml-5 mr-5" style={{ color: '#b1b6c3', fontSize: '12px', marginBottom: '8px' }}>
								Bankroll
							</div>
							{!bankrollEditable ? (
								<div
									className="mt-2 mb-4 ml-5 mr-5 bankroll-edit-container"
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: '8px',
										padding: '8px 12px',
										borderRadius: '8px',
										backgroundColor: '#22262e',
										cursor: 'pointer',
										transition: 'background-color 0.2s',
										width: 'fit-content',
										minWidth: '150px',
									}}
									onMouseEnter={(e) => {
										e.currentTarget.style.backgroundColor = '#2a2e36';
									}}
									onMouseLeave={(e) => {
										e.currentTarget.style.backgroundColor = '#22262e';
									}}
									onClick={() => {
										setBankrollEditable(true);
									}}>
									<span style={{ color: 'white', fontSize: '20px', fontWeight: 600 }}>${formatNumber(displayBankroll)}</span>
								</div>
							) : (
								<div
									className="mt-2 mb-4 ml-5 mr-5 bankroll-edit-container"
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: '8px',
										padding: '8px 12px',
										borderRadius: '8px',
										backgroundColor: '#22262e',
										width: 'fit-content',
										minWidth: '150px',
									}}>
									<span style={{ color: 'white', fontSize: '20px', fontWeight: 600 }}>$</span>
									<input
										type="text"
										inputMode="numeric"
										className="bankroll-input"
										style={{
											border: 'none',
											outline: 'none',
											backgroundColor: 'transparent',
											color: 'white',
											fontSize: '20px',
											fontWeight: 600,
											width: '100px',
											padding: 0,
											pointerEvents: 'auto',
										}}
										value={formatNumber(displayBankroll || '')}
										onChange={(e) => {
											const inputValue = e.target.value;
											// Remove commas and other non-numeric characters (except decimal point)
											let value = inputValue.replace(/[^0-9.]/g, '');
											// Prevent multiple decimal points
											const parts = value.split('.');
											if (parts.length > 2) {
												value = parts[0] + '.' + parts.slice(1).join('');
											}
											
											// Update state if setBankroll is available
											if (setBankroll && typeof setBankroll === 'function') {
												setBankroll(value);
											} else {
												// Fallback: update local state
												setLocalBankroll(value);
											}
											
											// Save bankroll (debounced) - always save regardless of setBankroll availability
											const currentUserdb = JSON.parse(window.localStorage.getItem('userdb'));
											const emailToUse = email || currentUserdb?.email;
											if (emailToUse) {
												saveBankrollDebounced(value, emailToUse);
											}
										}}
										onBlur={() => {
											setBankrollEditable(false);
											// Save immediately on blur
											if (bankrollSaveTimeoutRef.current) {
												clearTimeout(bankrollSaveTimeoutRef.current);
											}
											const currentUserdb = JSON.parse(window.localStorage.getItem('userdb'));
											const emailToUse = email || currentUserdb?.email;
											const valueToSave = setBankroll ? bankroll : localBankroll;
											if (emailToUse && valueToSave && !isNaN(parseFloat(valueToSave))) {
												// Force immediate save
												setTimeout(async () => {
													try {
														const copy = JSON.parse(window.localStorage.getItem('userdb'));
														if (copy?.user_data) {
															for (const c of copy.user_data) {
																c.bankroll = valueToSave;
															}
															window.localStorage.setItem('userdb', JSON.stringify(copy));
														}
														await saveBankroll(valueToSave, emailToUse);
													} catch (e) {
														console.error('Error saving bankroll on blur:', e);
													}
												}, 0);
											}
										}}
										onKeyDown={(e) => {
											if (e.key === 'Enter') {
												e.target.blur();
											}
										}}
										ref={bankrollbuttonref}
										autoComplete="off"
									/>
								</div>
							)}
							<div className="flex flex-row ml-5 pt-3 pb-3 cursor-pointer link pl-2">
								<img src={youtubeicon} alt="youtube icon" />
								<div
									onClick={async () => {
										// await axios.get(`${process.env.REACT_APP_BACKEND_URL}/intro_completed?intro_completed=false&email=${user.email}`, {
										// 	headers: {
										// 		Authorization: `Bearer ${window.localStorage.getItem('access_token')}`,
										// 	},
										// });
										// window.location.reload();
										setIsVideoModalOpen(true);
									}}
									className="ml-3"
									style={{ color: '#b1b6c3' }}>
									Tutorials and Resources
								</div>
								<Modal open={isVideoModalOpen} onClose={() => setIsVideoModalOpen(false)}>
									<div
										style={{
											position: 'relative',
											justifySelf: 'center',
											border: '1px solid #23262F',
											borderRadius: '10px',
											backgroundColor: '#22262e',
											marginTop: '12vh',
											width: '80%',
											outline: 'none',
										}}>
										{/* Close Button */}
										<button
											onClick={() => setIsVideoModalOpen(false)}
											style={{
												position: 'absolute',
												top: 10,
												right: 10,
												background: 'transparent',
												border: 'none',
												color: 'white',
												fontSize: '1.5rem',
												cursor: 'pointer',
											}}
											aria-label="Close">
											&times;
										</button>

										<div style={{ textAlign: 'center', padding: 10, marginRight: 20, marginLeft: 20, marginTop: 20 }}>
											<VimeoEmbed videoId="1075849944?h=717c54798f" />
										</div>
									</div>
								</Modal>
							</div>
							<div className="flex flex-row ml-5 pt-3 pb-3 cursor-pointer link pl-2">
								<img src={discordicongrey} alt="youtube icon" />
								<div
									onClick={() => {
										window.open('https://t.co/Z41E3czDHW');
									}}
									className="ml-3"
									style={{ color: '#b1b6c3' }}>
									Discord Community
								</div>
							</div>
							{plan !== 'Free' && (
								<div className="flex flex-row ml-5 pt-3 pb-3 cursor-pointer link pl-2">
									<img src={settingsicon} alt="account icon" />
									<div
										onClick={() => {
											window.open(paymentLink, '_blank');
										}}
										className="ml-3"
										style={{ color: '#b1b6c3' }}>
										Account Settings
									</div>
								</div>
							)}

							<div
								onClick={() => {
									logout({ logoutParams: { returnTo: window.location.origin } });
									window.location.reload();
								}}
								className="flex flex-row mb-4 ml-5 pt-3 pb-3 cursor-pointer link pl-2">
								<img src={logouticon} alt="youtube icon" />
								<div className="ml-3" style={{ color: '#b1b6c3' }}>
									<LogoutButton
										logoutfunction={() => {
											window.localStorage.removeItem('userdb');
											logout({ logoutParams: { returnTo: window.location.origin } });
											window.location.reload();
										}}
									/>
								</div>
							</div>
						</div>
					</Popover>

					<Popover
						open={isDiscordOpen}
						anchorEl={anchorElDiscord}
						id="user menu"
						onClose={() => {
							setIsDiscordOpen(false);
						}}
						sx={{
							'& .MuiPaper-root': {
								backgroundColor: '#17191d', // Your desired color
								width: '350px',
							},
						}}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'left',
						}}>
						<>
							{!userdb?.discord_verified && (
								<div>
									{}
									<div className="pt-4 pr-4" style={{ justifySelf: 'center' }}>
										<img style={{ justifySelf: 'center' }} src={discordicon} alt="discord logo" />

										<div className="mb-4" style={{ color: '#f9f9f9', textAlign: 'center' }}>
											Get EV scanner notifications sent to your Discord DMs
										</div>
										<div className="pl-6">
											<label style={{ color: '#f9f9f9' }}>Enter your discord Username</label>
											<input
												value={discordUsername}
												onChange={(e) => {
													setDiscordUsername(e.target.value);
												}}
												className="mt-1 mb-4 mr-2 pl-2"
												style={{ backgroundColor: '#363844', borderRadius: '8px', height: '40px', color: '#f9f9f9' }}
												placeholder="Example: BasicallyAGoalie"
											/>
										</div>
										<div>
											<div
												onClick={async () => {
													console.log('set discord username');
													await verifyDiscordUsername(email, discordUsername);
												}}
												className="ml-6 mb-6 cursor-pointer verify-button"
												style={{ height: '50px', alignContent: 'center', backgroundColor: '#0b63f4', borderRadius: '8px', color: '#f9f9f9', textAlign: 'center' }}>
												Verify Discord Username
											</div>
										</div>
									</div>
								</div>
							)}
							{userdb?.discord_verified && (
								<div>
									<div style={{ color: '#abb0be', border: '1px solid #373945', borderRadius: 6, padding: 6, margin: 12 }}>
										Connected via Discord
										<div className="flex flex-row">
											<img src={discord_logo_icon} alt="discord logo" />
											<div
												style={{
													width: 8,
													height: 8,
													backgroundColor: isDiscordEnabled ? '#47E338' : 'red',
													borderRadius: '50%',
													alignSelf: 'center',
													marginLeft: 12,
												}}
											/>
											<div style={{ color: 'white', marginLeft: 12, alignContent: 'center' }}>{userdb?.discord_username_original}</div>
										</div>
									</div>
									<div className="flex flex-row">
										<div style={{ margin: 12, color: '#abb0be' }}>Enable Discord notifications?</div>
										<div>
											<IOSSwitch
												sx={{ m: 1 }}
												onChange={async (e) => {
													await setDiscordEnabled(email, !isDiscordEnabled);
													const copy = JSON.parse(JSON.stringify(userdb));
													copy.discord_enabled = String(!isDiscordEnabled);
													window.localStorage.setItem('userdb', JSON.stringify(copy));
													setIsDiscordEnabled(!isDiscordEnabled);
												}}
												checked={isDiscordEnabled}
											/>
										</div>
									</div>
									<div
										onClick={() => {
											// TODO: open notifications filters
											setFiltersOpen('notifications');
										}}
										className="manage-filters-button"
										style={{
											marginTop: 20,
											marginLeft: 12,
											marginRight: 12,
											backgroundColor: '#0b63f4',
											borderRadius: 6,
											minHeight: 40,
											alignContent: 'center',
											cursor: 'pointer',
										}}>
										<div style={{ justifyContent: 'center' }} className="flex flex-row">
											<span>
												<img src={filter_icon} alt="filter icon" />
											</span>
											<div style={{ color: 'white' }}>Manage filters</div>
										</div>
									</div>
									<div style={{ marginLeft: 12, marginRight: 12, marginTop: 12, marginBottom: 12, height: 1, backgroundColor: '#363844' }} />
									<div
										onClick={async () => {
											const copy = JSON.parse(window.localStorage.getItem('userdb'));

											if (copy.discord_verified) {
												const access_token = window.localStorage.getItem('access_token');
												if (!access_token) {
													window.location.reload();
												}
												await axios.get(`${process.env.REACT_APP_BACKEND_URL}/disconnect_discord?email=${email}`, {
													headers: {
														Authorization: `Bearer ${access_token}`,
													},
												});
												copy.discord_verified = false;
												copy.discord_username = '';
												copy.discord_username_original = '';
												copy.discord_status = 'unverified';
												window.localStorage.setItem('userdb', JSON.stringify(copy));
												window.location.reload();
											}
										}}
										style={{ margin: 12, cursor: 'pointer' }}
										className="flex flex-row">
										<img src={close_icon} alt="close icon" />
										<div style={{ color: '#abb0be' }}>Disconnect ID</div>
									</div>
									{/* <img style={{ padding: '26px', justifySelf: 'center' }} src={verifiedicon} alt="verified" /> */}
								</div>
							)}
						</>
					</Popover>
					{isMobile && <img style={{ marginTop: 'auto', marginBottom: 'auto' }} className="mr-4 mobile-logo" src={wagerwizlogonew} alt="wager wiz logo" />}
				</div>
			</div>
		</div>
	);
};

function SidebarMobileMenuButton({ bankroll, setBankroll, email, profilepic, profilename, paymentLink }) {
	const [open, setOpen] = useState(false);
	return (
		<>
			{!open && (
				<IconButton onClick={() => setOpen(true)} sx={{ ml: 1, zIndex: 3000 }}>
					<MenuIcon sx={{ color: 'white' }} />
				</IconButton>
			)}
			{open && (
				<>
					<SidebarMobile openOverride={open} setOpenOverride={setOpen} bankroll={bankroll} setBankroll={setBankroll} profilepic={profilepic} profilename={profilename} paymentLink={paymentLink} />
					<IconButton
						onClick={() => setOpen(false)}
						sx={{ position: 'fixed', top: 16, right: 16, zIndex: 4000, color: 'white', backgroundColor: 'rgba(23,25,29,0.5)' }}
					>
						<CloseIcon />
					</IconButton>
				</>
			)}
		</>
	);
}
